'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var DEFAULT_FORMATTER_COMPONENTS_MAP = {
  postalCode: 'postalCode',
  postalCodeSuffix: 'postalCodeSuffix',
  street: 'street',
  streetNumber: 'streetNumber',
  subpremise: 'subpremise',
  country: 'country',
  county: 'county',
  state: 'state',
  city: 'city'
};
function formatAddressComponents(components) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var {
    componentsMap = DEFAULT_FORMATTER_COMPONENTS_MAP,
    shouldIncludePostalCodeSuffix = false,
    shouldIncludeSubpremise = false,
    shouldIncludeCounty = false,
    shouldIncludeCountry = false,
    lineSeparator = '\n'
  } = options;

  function getComponent(mapKey) {
    var _componentsMap$mapKey, _components$component;

    var componentKey = (_componentsMap$mapKey = componentsMap[mapKey]) !== null && _componentsMap$mapKey !== void 0 ? _componentsMap$mapKey : '';
    return (_components$component = components[componentKey]) !== null && _components$component !== void 0 ? _components$component : '';
  }

  var postalCode = getComponent('postalCode');
  var postalCodeSuffix = getComponent('postalCodeSuffix');
  var formattedPostalCode = shouldIncludePostalCodeSuffix && Boolean(postalCodeSuffix) ? "".concat(postalCode, "-").concat(postalCodeSuffix) : postalCode;
  var streetNumber = getComponent('streetNumber');
  var street = getComponent('street');
  var subpremise = shouldIncludeSubpremise ? getComponent('subpremise') : '';
  var formattedStreetAddress = [streetNumber, street, subpremise].filter(x => x).join(' ');
  var city = getComponent('city');
  var county = shouldIncludeCounty ? getComponent('county') : '';
  var state = getComponent('state');
  var formattedCityState = [city, county, state].filter(x => x).join(', ');
  var country = shouldIncludeCountry ? getComponent('country') : '';
  var result = [formattedStreetAddress, "".concat(formattedCityState, " ").concat(formattedPostalCode), country].filter(x => x).join(lineSeparator);
  return result;
}

exports.formatAddressComponents = formatAddressComponents;
